export default __webpack_public_path__ + "static/media/visual_website_optimizer.08ec207f.svg";